module.exports = __webpack_public_path__ + "img/index-desc-2-pic.59493108.png";